<app-header [active]="0" [circuito]="circuito"></app-header>
<div class=" screen-table">
  <div style="display:flex;justify-content:flex-end;padding:8px 16px 0;">
    <a routerLink="/vincular-tv" class="btn btn-outline-dark" style="font-size: 14px;">Vincular TV</a>
  </div>
  <div *ngIf="unlinkError" class="alert alert-danger" style="font-size: 13px; margin: 8px 16px 0;">{{unlinkError}}</div>
  <table class="table">
    <thead>
    <tr>
      <th>ID</th>
      <th>Equipo</th>
      <th>Evento</th>
      <th>Fecha</th>
      <th>IP</th>
      <th>Grupo</th>
      <th>Version</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let screen of screens; let j = index">
      <th scope="row">{{screen.idPos}}</th>
      <td>{{screen.nombre}}</td>
      <td>{{screen.evento}}</td>
      <td>{{screen.fecha_relativa}}</td>
      <td>{{screen.ip}}</td>
      <td>{{screen.nombreGrupo}}</td>
      <td>{{screen.version}}</td>
      <!-- contratos-congelados T7 restore point (Q5): whole actions control
           gated behind combined multicaja||monitoreo via actionsAllowed$
           (hidden ONLY when both flags are explicitly false; missing flags
           stay visible). PO per-action split pending: when PO names which
           sendAction values are multicaja vs monitoreo, split this container
           into per-button *ngIf gates without restructuring. -->
      <td *ngIf="actionsAllowed$ | async" style="text-align: right" class="cell-options">

        <div class="btn-group">

          <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
            <button class="btn row-option-button" ngbDropdownToggle (click)="showOptionesRow(screen)">
              <img src="../../../assets/img/captarmedia-estado-settings.png" class="row-option-icon">
              <img src="../../../assets/img/noesys-login.png" class="row-option-icon">
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
              <a class="dropdown-item" (click)="setAction(screen.idPos,'restart')">Restart</a>
              <a class="dropdown-item" (click)="setAction(screen.idPos,'reboot')">Reboot</a>
              <a class="dropdown-item" (click)="setAction(screen.idPos,'files')">Files</a>
              <a class="dropdown-item" (click)="setAction(screen.idPos,'reinstallmanager')">Install Manager</a>
              <a class="dropdown-item" (click)="setAction(screen.idPos,'reinstallplayer')">Install Player</a>
              <a class="dropdown-item" (click)="askUnlink(screen)">Desvincular</a>
            </div>
          </div>
        </div>
        <div ngbDropdown class="btn-group dropleft">
          <div class="dropdown-menu">
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>

<app-confirm-modal *ngIf="showUnlinkModal"
                   titulo="Desvincular TV"
                   mensaje="Se va a revocar la vinculación de este TV. El historial se conserva y el TV va a requerir un nuevo vínculo o IDs manuales."
                   botonConfirmar="Desvincular"
                   botonCancelar="Cancelar"
                   (onConfirm)="confirmUnlink()"
                   (onCancel)="cancelUnlink()"
                   (onClose)="cancelUnlink()">
</app-confirm-modal>




// WEBPACK FOOTER //
// ./src/app/admin/home/home.component.html